import React, { useEffect, useState } from "react";
import banner from "../../assets/images/banner.png";
import discover from "../../assets/images/classydiscover.jpg";
import { PiGreaterThanLight } from "react-icons/pi";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import Menu from "../../component/food-types/continentalMenu";
import { ApiCaller } from "../../config/api/api";
import defaultImage from "../../assets/images/1.jpg";
import Service from "../services/service";
import barMenu from "../../assets/images/bar.png";
import foodMenu from "../../assets/images/food.png";

const Home = () => {
  const [showQRCode, setShowQRCode] = useState(false);
  const [qrCodeType, setQrCodeType] = useState("food");
  const [galleryData, setGalleryData] = useState(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    vertical: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          vertical: true,
          verticalSwiping: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          vertical: false,
          verticalSwiping: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          vertical: false,
          verticalSwiping: false,
        },
      },
    ],
  };

  const toggleQRCode = (type = "food") => {
    setQrCodeType(type);
    setShowQRCode((prev) => !prev);
  };

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const data = await ApiCaller("gallery/", "GET");
        setGalleryData(data);
      } catch (error) {
        console.error("error in gallery api", error.message);
      }
    };
    fetchGallery();
  }, []);
  return (
    <div>
      <section className="hero">
        <div className="relative z-10">
          <div
            style={{ backgroundImage: `url(${banner})` }}
            className="bg-center w-full bg-cover z-[-1] bg-no-repeat relative top-0 lg:top-[-3.99em] pt-20 lg:pt-48 h-[40vh] lg:h-screen"
          >
            <div className="absolute inset-0 bg-black/65"></div>
            <div className="relative">
              <Slider {...settings}>
                <div className="font-bold z-10">
                  <div className="text-white text-2xl md:text-4xl lg:text-6xl font-fairDisplay">
                    <span className="flex justify-center">
                      CLASSY CAFE BAR &
                    </span>
                    <span className="flex justify-center">RESTAURANT</span>
                  </div>
                  <div className="text-white font-light text-center py-3">
                    ULTIMATE DINING EXPERIENCE LIKE NO OTHER
                  </div>
                  <div className="flex gap-4 items-center justify-center">
                    <div>
                      <button
                        onClick={() => toggleQRCode("bar")}
                        className="bg-transparent flex items-center gap-2 border border-white text-white rounded-full lg:px-8 lg:py-2 px-3 py-1"
                        aria-label="Show QR Code"
                      >
                        QR <PiGreaterThanLight className="text-xs" />
                      </button>
                    </div>
                    <div>
                      <Link
                        to="/barmenu"
                        className="bg-amber-400 flex items-center gap-3 border border-white text-white rounded-full whitespace-nowrap lg:px-8 lg:py-2 px-3 py-1 text-xs lg:text-xl"
                        aria-label="Browse Bar Menu"
                      >
                        Browse Bar Menu
                        <PiGreaterThanLight className="text-xs" />
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="font-bold z-10">
                  <div className="text-white text-2xl md:text-4xl lg:text-6xl font-fairDisplay">
                    <span className="flex justify-center">
                      LIVE ARTISTE AND A COZY
                    </span>
                    <span className="flex justify-center">ENVIRONMENT</span>
                  </div>
                  <div className="text-white font-light text-center py-3">
                    WE SERVE MULTI CUISINES WITH UNLIMITED DELIGHTS & FINEST
                    DRINKS TO QUENCH YOUR THIRST
                  </div>
                  <div className="flex gap-4 items-center justify-center">
                    <div>
                      <button
                        onClick={() => toggleQRCode("food")}
                        className="bg-transparent flex items-center gap-2 border border-white text-white rounded-full lg:px-8 lg:py-2 px-3 py-1"
                        aria-label="Show QR Code"
                      >
                        QR <PiGreaterThanLight className="text-xs" />
                      </button>
                    </div>
                    <div>
                      <Link
                        to="/foodmenu"
                        className="bg-amber-400 flex items-center gap-3 border border-white text-white rounded-full whitespace-nowrap lg:px-8 lg:py-2 px-3 py-1 text-xs lg:text-xl"
                        aria-label="Browse Food Menu"
                      >
                        Browse Food Menu
                        <PiGreaterThanLight className="text-xs" />
                      </Link>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
        <div className="relative group">
          <div className="bg-green-600 w-full p-4 text-white overflow-hidden relative bottom-0 lg:bottom-[4.3em]">
            <Link to="/partypackages">
              <div className="whitespace-nowrap animate-marquee group-hover:[animation-play-state:paused]">
                Throw the ultimate party! Choose from IMFL, Deluxe & Imported
                Packages starting at ₹1800. Unlimited drinks & food! Reserve
                now!
              </div>
            </Link>
          </div>
        </div>
      </section>
      {showQRCode && (
        <div className="fixed h-screen w-screen bg-black inset-0 flex items-center justify-center z-10">
          <div className="bg-white p-4 rounded-lg">
            <img
              src={qrCodeType === "bar" ? barMenu : foodMenu}
              className="h-72"
              alt="menu"
            />
            <button
              onClick={() => setShowQRCode(false)}
              className="mt-2 w-full bg-amber-400 text-white py-1 rounded"
              aria-label="Close QR Code"
            >
              Close
            </button>
          </div>
        </div>
      )}
      <section className="px-5 sm:px-14 md:px-16 lg:px-28">
        <div className="text-center font-semibold text-2xl lg:text-4xl font-fairDisplay mb-8">
          Our Speciality
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
          {galleryData && galleryData.results
            ? galleryData.results
                .filter(
                  (value, index, self) =>
                    self.findIndex(
                      (item) =>
                        item.gallery_type_display === value.gallery_type_display
                    ) === index
                )
                .map((val, id) => (
                  <div key={id}>
                    <Link to={`/g/${val.gallery_type}`}>
                      <div>
                        <img
                          src={val.file_url || defaultImage}
                          alt="val.file_url"
                          className="w-full h-64 rounded-md object-cover"
                        />
                      </div>
                      <div className="font-fairDisplay font-semibold text-center text-lg">
                        {val.gallery_type_display}
                      </div>
                    </Link>
                  </div>
                ))
            : galleryData
            ? galleryData.results
                .filter(
                  (value, index, self) =>
                    self.findIndex(
                      (item) =>
                        item.gallery_type_display === value.gallery_type_display
                    ) === index
                )
                .map((_, idx) => (
                  <div
                    key={idx}
                    className="w-full h-[12em] bg-black rounded-md animate-pulse"
                  ></div>
                ))
            : Array.from({ length: 4 }).map((_, idx) => (
                <div
                  key={idx}
                  className="w-full h-[12em] bg-black rounded-md animate-pulse"
                ></div>
              ))}
        </div>
      </section>
      <section className="py-14 px-5 sm:px-14 md:px-16 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg-grid-cols-2 gap-6">
          <div>
            <img src={discover} alt="lorem_img" className="w-full rounded-md" />
          </div>
          <div>
            <div className="font-bold font-fairDisplay text-2xl lg:text-4xl">
              Discover Us
            </div>
            <div className="font-sans text-xl font-light text-gray-600 py-4 relative">
              Feed your soul with a fist of “CLASSY CAFÉ BAR AND RESTAURANT” one
              of the finest Restaurant in Delhi
              <div className="after:absolute after:content-['.....'] after:bottom-[-10px] after:tracking-widest after:text-6xl"></div>
            </div>
            <div className="text-sm leading-6 text-gray-800 mt-5">
              DISCOVER US Feed your soul with a fist of “CLASSY CAFÉ BAR AND
              RESTAURANT” one of the finest Restaurant in Delhi We combine the
              finest traditional Indian cooking and multi-cuisines. Hospitality
              runs throughout Classy Café Bar & Restaurant, from the warm
              welcome at the door to the merry staffs, making the story of this
              kitchen delightful one from your first drink to your last bite. It
              is a place where you can grab a great coffee, have a talk,
              socialize , feed the children or indulge yourself in a proper
              evening out, cocktails, wine and delicious food. We are situated
              in the heart of Delhi.
            </div>
          </div>
        </div>
      </section>
      <section>
        <Menu />
      </section>
      <section
        className="py-14 px-5 sm:px-14 md:px-16 lg:px-20 bg-fixed bg-cover bg-center"
        style={{ backgroundImage: "url('/backgrondimage/chicken-satay.jpg')" }}
      >
        <div className="text-4xl text-white font-fairDisplay font-bold text-center">
          Memorable Experience With Delicious Food
        </div>
        <div className="text-center font-normal text-white font-sans py-6 relative">
          Whether its your gang, the good food, the drinks, the music, the
          ambiance
          <span className="block">
            or the hospitality, all we want is your visit to be a memorable one.
          </span>
          <div className="after:absolute after:content-['........'] after:bottom-[-26px] after:right-[22%] md:after:right-[40%]  lg:after:right-[40%] after:tracking-[0.7em] after:text-2xl"></div>
        </div>
        <div className="text-center mt-10">
          <a
            href="https://www.zomato.com/ncr/classy-cafe-bar-restaurant-south-extension-1-new-delhi"
            target="_blank"
            rel="noopener noreferrer"
            className="border border-white rounded-full text-white hover:bg-[#e6af4b] px-7 py-3"
          >
            Click to order
          </a>
        </div>
      </section>
      <section
        className="bg-fixed bg-cover bg-center mb-10 md:mb-20 lg:mb-24"
        style={{ backgroundImage: "url('/backgrondimage/service.jpg')" }}
      >
        <Service />
      </section>
    </div>
  );
};

export default Home;
